import { createApi } from '@reduxjs/toolkit/query/react';

import { TPaymentResponse } from '@/types/payments';

import { baseQueryWithReauth } from './utils';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getPayments: build.query({
      query: (params: {
        customerId: string;
        page: number;
        limit: number;
        }) => ({
        url: 'payment/get-payments',
        method: 'POST',
        body: {
          ...params,
        },
      }),
      transformResponse: (response: TPaymentResponse) => response,
    }),
  })
});

export const {
  useGetPaymentsQuery,
} = paymentApi;